// Autogenerated app version number generated by deploy/extract-version.js
export const APP_VERSION = '0.0.348';